'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderAuthorLink = function renderAuthorLink(author, target, renderAsLink) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (renderAsLink) {
    return _react2.default.createElement(
      _reactRouter.Link,
      {
        key: index,
        className: 'author-link',
        activeClassName: 'active-search-link',
        target: target,
        rel: 'noopener noreferrer',
        to: { pathname: '/v2/search', query: { query: author, searchType: 'author' } } },
      author
    );
  }

  return _react2.default.createElement(
    'div',
    { key: index, className: 'author-link' },
    author
  );
};

function AuthorLink(_ref) {
  var _ref$authors = _ref.authors,
      authors = _ref$authors === undefined ? [] : _ref$authors,
      _ref$target = _ref.target,
      target = _ref$target === undefined ? '_parent' : _ref$target,
      _ref$renderAsLink = _ref.renderAsLink,
      renderAsLink = _ref$renderAsLink === undefined ? true : _ref$renderAsLink;

  var normalizedAuthors = Array.isArray(authors) ? authors : authors.toJS();

  if (normalizedAuthors.length) {
    if (normalizedAuthors.length >= 1) {
      var links = normalizedAuthors.map(function (author, i) {
        return _react2.default.createElement(
          'span',
          { key: author + '-' + i },
          renderAuthorLink(author, target, renderAsLink, i),
          i < normalizedAuthors.length - 1 ? ' • ' : ''
        );
      });

      return _react2.default.createElement(
        'span',
        { className: 'author-link-list' },
        links
      );
    }

    return _react2.default.createElement(
      'span',
      { className: 'author-link-list' },
      renderAuthorLink(normalizedAuthors[0], target, renderAsLink)
    );
  }

  return _react2.default.createElement('noop', null);
}

AuthorLink.propTypes = {
  authors: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)]),
  target: _react.PropTypes.string,
  renderAsLink: _react.PropTypes.bool
};

AuthorLink.displayName = 'AuthorLink';

exports.default = AuthorLink;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-author-link/lib/components/AuthorLink.component.js
// module id = 1026
// module chunks = 1